import type { RelatedBulletin } from '../types';

export const sortRelatedBulletins = (bulletins: RelatedBulletin[]): RelatedBulletin[] => {
  return [...bulletins].sort((a, b) => {
    if (a.active !== b.active) {
      return a.active ? -1 : 1;
    }
    const dateA = a.date_create ? new Date(a.date_create).getTime() : 0;
    const dateB = b.date_create ? new Date(b.date_create).getTime() : 0;
    return dateB - dateA;
  });
};
